// extracted by mini-css-extract-plugin
export default {"ImageHalfSize":"ImageHalfSize_ImageHalfSize__9NF4K","slideshow":"ImageHalfSize_slideshow__GpX3M"};